<Demo on:submitMessage="submitMessage(event)"/>
<div>
  <div></div>
  <div class="sc-launcher" class:opened="active" on:click="toggleChat()">
    <MessageCount/>
    <img class="sc-open-icon" src={launcherIconActive} />
    <img class="sc-closed-icon" src={launcherIcon} />
  </div>
  <ChatWindow on:closechat="closeChat()" bind:active=active />
</div>

<style>
 .sc-launcher {
   width: 60px;
   height: 60px;
   background-color: #4e8cff;
   background-position: center;
   background-repeat: no-repeat;
   position: fixed;
   right: 25px;
   bottom: 25px;
   border-radius: 50%;
   box-shadow: none;
   transition: box-shadow 0.2s ease-in-out;
 }

 .sc-launcher:before {
   content: '';
   position: relative;
   display: block;
   width: 60px;
   height: 60px;
   border-radius: 50%;
   transition: box-shadow 0.2s ease-in-out;
 }

 .sc-launcher .sc-open-icon,
 .sc-launcher .sc-closed-icon {
   width: 60px;
   height: 60px;
   position: fixed;
   right: 25px;
   bottom: 25px;
   transition: opacity 100ms ease-in-out, transform 100ms ease-in-out;
 }

 .sc-launcher .sc-closed-icon {
   transition: opacity 100ms ease-in-out, transform 100ms ease-in-out;
   width: 60px;
   height: 60px;
 }

 .sc-launcher .sc-open-icon {
   padding: 20px;
   box-sizing: border-box;
   opacity: 0;
 }

 .sc-launcher.opened .sc-open-icon {
   transform: rotate(-90deg);
   opacity: 1;
 }

 .sc-launcher.opened .sc-closed-icon {
   transform: rotate(-90deg);
   opacity: 0;
 }

 .sc-launcher.opened:before {
   box-shadow: 0px 0px 400px 250px rgba(148, 149, 150, 0.2);
 }

 .sc-launcher:hover {
   box-shadow: 0 0px 27px 1.5px rgba(0,0,0,0.2);
 }

</style>

<script>
 import MessageCount from './MessageCount.html';
 import ChatWindow from './ChatWindow.html';
 import Demo from './Demo.html';

 export default {
   components: {
     MessageCount, ChatWindow, Demo
   },

   data: function() {
     return  {
       launcherIcon: 'assets/img/logo-no-bg.svg',
       launcherIconActive: 'assets/img/close-icon.png',
       active: false
     }
   },

   methods: {
     closeChat() {
       console.log('close chat window');
       this.set({active: false });
     },

     toggleChat() {
       console.log('toggle chat');
       const { active } = this.get();
       this.set({active : !active});
     },

     submitMessage(event) {
       debugger
       console.log('ss');
     }

   }

 }


</script>
